<!--https://codepen.io/RRoberts/pen/ZBYaJr-->

<div (click)="onClick()" class="hamburger {{isChecked && 'is-active'}}" id="hamburger-2">
    <span class="line"></span>
    <span class="line"></span>
    <span class="line"></span>
</div>
